
export const filter = {
  darkMode: `none`,
} as const;


